const isResourceRootFolder = (folder) => {
  return folder.id === folder.root?.id;
};

export { isResourceRootFolder };
//# sourceMappingURL=isResourceRootFolder.js.map
